import React from 'react';

const MenuContext = React.createContext();
export default MenuContext;
